import { Navigate } from "react-router";
import { Route, Routes } from "react-router-dom";
import AgentCollectionHistoryPage from "../Pages/AgentCollectionHistoryPage";
import AgentPage from "../Pages/AgentPage";
import AllMemberPage from "../Pages/AllMemberPage";
import DashboardPage from "../Pages/DashboardPage";
import LoginPage from "../Pages/LoginPage";
import MemberLoginPage from "../Pages/MemberLoginPage";
import MyMemberPage from "../Pages/MyMemberPage";
import ReportPage from "../Pages/AgentWalletHistoryPage";
import UserSettingPage from "../Pages/UserSettingPage";
import ProtectedRoute from "./Utilities/ProtectedRoute";
import ProtectedMemberPanelRoute from "./Utilities/ProtectedMemberPanelRoute";
import MemberPanelDashboardComponent from "../Component/MemberPanelDashboardComponent/MemberPanelDashboardComponent";
import PromisedPage from "../Pages/PromisedPage";
import AgentWalletHistoryPage from "../Pages/AgentWalletHistoryPage";
import CollectionHistory from "../Pages/CollectionHistory";

import PrintPage from "../Pages/PrintPage";

function AppRoute(props) {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to={"/dashboard"} />} />
        {/* member login */}
        {/* <Route path="/member-login" element={<MemberLoginPage />} />
        <Route
          path="/member-panel"
          element={
            <ProtectedMemberPanelRoute>
              <MemberPanelDashboardComponent />
            </ProtectedMemberPanelRoute>
          }
        /> */}
        {/*login route*/}
        <Route path="/login" element={<LoginPage />} />
        {/*dashboard route*/}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute permissions={["*"]}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/collector"
          element={
            <ProtectedRoute permissions={["*"]}>
              <AgentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-profile"
          element={
            <ProtectedRoute permissions={["*"]}>
              <AgentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-donor"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <AllMemberPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/promised"
          element={
            <ProtectedRoute permissions={["*"]}>
              <PromisedPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent-wallet-history"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <AgentWalletHistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/print"
          element={
            <ProtectedRoute permissions={["*"]}>
              <PrintPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/collection-history"
          element={
            <ProtectedRoute permissions={["*"]}>
              <CollectionHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent-history"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <AgentWalletHistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent-collection-history"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <AgentCollectionHistoryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-donor"
          element={
            <ProtectedRoute permissions={["*"]}>
              <MyMemberPage />
            </ProtectedRoute>
          }
        />


        <Route
          path="/setting"
          element={
            <ProtectedRoute permissions={["*"]}>
              <UserSettingPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default AppRoute;
